export default __webpack_public_path__ + "static/oli-3a7ebac48ed78e2eca487814c398778f.png";